export default "__VITE_ASSET__vhf$$4ty__"